
(function () {
  function enableProductCompare() {
    const toggle = document.querySelector("[data-compare-toggle]");

    if (!toggle) return;

    if (!toggle.checked) {
      toggle.checked = true;
      toggle.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  document.addEventListener("DOMContentLoaded", enableProductCompare);

  window.addEventListener("load", function () {
    setTimeout(enableProductCompare, 500);
    setTimeout(enableProductCompare, 1500);
  });
})();
